import Work1 from "../assets/workno1.jpg"
import Work2 from "../assets/portfolioimg.png"
import Work3 from "../assets/foodrushhome.png"
import Work4 from "../assets/facereco.jpg"
import Work5 from "../assets/workno5.png"
import Work6 from "../assets/workno6.png"
import Work7 from "../assets/Google Meet Static Page Clone (1).png"
import Work8 from "../assets/Simple Calulator UI.png"
import Work9 from "../assets/work8.png"
import Work10 from "../assets/workno3.png"
import Work11 from "../assets/testusplushome.png"
import Work12 from "../assets/rabdiwalahome.png"

export const projectsData = [
    {
        id:1,
        image: Work3,
        title:'FoodRush : The Food Delivery App',
        category:"Web",
        link:"https://food-rush-alpha.vercel.app/"
    },
   
    {
        id:2,
        image: Work2,
        title:'PortFolio',
        category:"Web",
        link:"https://github.com/cwadyalkar/Chirag-Portfolio-Website"
    },
    {
        id:3,
        image: Work1,
        title:'Dr Oncall Application',
        category:"Web",
       link:"https://github.com/cwadyalkar/Chirag-Portfolio-Website"
    },
    {
        id:4,
        image: Work4,
        title:'Face Recognition Attendance System',
        category:"Web",
        link:"https://github.com/cwadyalkar?tab=repositories"
    },
    {
        id:5,
        image: Work11,
        title:'Testus Plus : Healthcare App',
        category:"Web",
        link:"https://github.com/cwadyalkar/TestusPlus"
    },
    {
        id:6,
        image: Work6,
        title:'Car Service Management System',
        category:"Web",
        link:"https://github.com/cwadyalkar?tab=repositories"
    },
    {
        id:7,
        image: Work10,
        title:'News Verse ',
        category:"Web",
        link:"https://github.com/cwadyalkar/News-Verse"
    },
   
    {
        id:8,
        image: Work12,
        title:'Rabdi Delight : World of Indian Desserts',
        category:"Web",
        link:"https://github.com/cwadyalkar/rabdiwala-project"
    },
    {
        id:9,
        image: Work9,
        title:'Practise Portfolio',
        category:"Web",
        link:"https://github.com/cwadyalkar/chirag-portfolio"
    },
    {
        id:10,
        image: Work7,
        title:'Google Meet Clone UI Static Page',
        category:"Design",
        link:"https://github.com/cwadyalkar/Google-Meet-Static-Home-Page-UI"
    },
    {
        id:11,
        image: Work5,
        title:'ChatGPT Static page Clone',
        category:"Design",
        link:"https://github.com/cwadyalkar/ChatGPT_Static_Page"
    },
    {
        id:12,
        image: Work8,
        title:'Simple Calculator App',
        category:"Design"
    },
]
export const projectsNav = [
    {
        name : "all"
    },
    {
        name : "Web"
    },
    {
        name : "Design"
    },
]